<div class="container">

  <app-header-dialog [iconName]="'local_bar'">
    Evento
  </app-header-dialog>

  <div id='print-section' class="preview">
    <div [innerHTML]='fullEvent'></div>
  </div>

  <div class="actions" style="margin-top:10px" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button printSectionId="print-section">
      <mat-icon class='icon-add'>print</mat-icon>
    </button>
  </div>

</div>